import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSFamiliaMaterialClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/familia-material');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Familia Material');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/familia-material', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Familia Material');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/familia-material', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Familia Material');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/familia-material/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Familia Material');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/familia-material/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Familia Material');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/familia-material/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Familia Material');
    }
  }
}
